<template>
  <div class="page">
    <!--导航栏  @click-left="onClickLeft"  left-arrow left-text="返回"-->
    <!-- <van-nav-bar title="业务员登录" fixed /> -->
    <!--导航栏-->

    <div class="container-logo">
      <div class="txt1">你好，欢迎来到</div>
      <div class="txt2">予益服务商平台</div>
    </div>

    <!--内容部分 start-->
    <van-form @submit="onSubmit" style="padding: 0 32px;background-color: #fff;">
      <div class="txt4">业务员编号</div>
      <van-field v-model="username" name="业务员编号" placeholder="请输入业务员编号"
        :rules="[{ required: true, message: '业务员编号不能为空' }]">
      </van-field>
      <div class="txt4">密码</div>
      <van-field v-model="password" type="password" name="密码" placeholder="请输入密码"
        :rules="[{ required: true, message: '密码不能为空' }]">
      </van-field>
      <div style="background-color: #fff;">
      <div style="padding-bottom: 16px;padding-top: 30px;box-sizing: border-box;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">
          登录并绑定
        </van-button>
      </div>
      <div class="txt3">
        ● 点击登录即表示您同意 《用户服务协议》
      </div>
    </div>
    </van-form>
    <!--内容部分 end-->
  </div>
</template>

<script>
import VueCookie from 'vue-cookies'
import { Notify, Toast } from 'vant'

export default {
  name: 'SalesmanLogin',
  data() {
    return {
      username: '',
      password: '',
      redirect: '',
      openid: ''
    }
  },
  created() {
    // 重定向地址
    this.redirect = this.$route.query.redirect
    if (this.redirect == undefined) {
      this.redirect = '/SalesmanHome'
    }
    this.openid = this.$route.query.openid
    // this.wxSalesman()
  },
  methods: {
    wxSalesman() {
      if (!this.openid) {
        this.openid = localStorage.getItem('openid')
      }
      var toast = Toast.loading({
        duration: 0,
        message: '自动登录中',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.$http.get('/wechat/api.agent/wxSalesman', {
        params: {
          'openid': this.openid
        }
      }).then(response => {
        toast.clear()
        if (response && response.data.code == 200) {
          VueCookie.set('salesmanInfo', response.data.data, 360000)
          window.sessionStorage.setItem('tag', 'salesman_log')
          window.localStorage.setItem('salesman_token', response.data.data.salesman_token)
          window.localStorage.setItem('salesman_id', response.data.data.id)
          this.$router.push(this.redirect)
        } else {
          Notify({ type: 'danger', message: response.data.msg })
        }
      })
    },
    onSubmit(values) {
      var toast = Toast.loading({
        duration: 0,
        message: '登录中',
        forbidClick: true,
        loadingType: 'spinner'
      })
      console.log('submit', values)
      this.$http.get('/wechat/api.agent/loginSalesman', {
        params: {
          username: this.username,
          password: this.password,
          openid: localStorage.getItem('openid')
          // openid: this.openid
        }
      }).then(response => {
        toast.clear()
        if (response && response.data.code == 200) {
          VueCookie.set('salesmanInfo', response.data.data, 360000)
          window.sessionStorage.setItem('tag', 'salesman_log')
          window.localStorage.setItem('salesman_token', response.data.data.salesman_token)
          window.localStorage.setItem('salesman_id', response.data.data.id)
          this.$router.push(this.redirect)
        } else {
          Notify({ type: 'danger', message: response.data.msg })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .van-field__control::-webkit-input-placeholder{
  color: #999 !important;
}

.page{
  width: 100%;
  height: 100vh;
  background-color: #fff;
}

.container-logo {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 32px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 4%, rgba(20, 134, 251, 1) 192%);

  .txt1 {
    font-weight: 300;
    font-style: normal;
    font-size: 20px;
    letter-spacing: 1px;
    line-height: 50px;
    color: #333333;
  }

  .txt2{
    font-weight: 700;
    font-style: normal;
    font-size: 26px;
    letter-spacing: 2px;
    line-height: 50px;
    color: #333333;
  }
}

.txt3{
  font-size: 14px;
  color: #999999;
  font-weight: 400;
  line-height: 20px;
}

.txt4{
  line-height: 50px;
  font-size: 12px;
  color: rgba(170, 170, 170, 0.9);
}
</style>
